import { Component, Input, OnInit } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { Router } from "@angular/router";

import { environment } from "src/environments/environment";

@Component({
  selector: 'app-omni',
  // standalone: true,
  // imports: [CommonModule, MatIconModule],
  templateUrl: './omni.component.html',
  styleUrls: ['./omni.component.scss']
})
export class OmniComponent implements OnInit {

 _dashboardId: string = "dfc27795-3f57-4369-9b99-136b6adb766b";
  @Input() quotedPriceId: any;

  @Input()
  set dashboardId(value: string) {
    this._dashboardId = value;
  }
  error: boolean = false;
  constructor(private httpClient: HttpClient, private router: Router) {}
  

  goHome() {
  this.router.navigate(['']);
}

goBack() {
  this.router.navigate(['']);
}

  ngOnInit(): void {
  //   console.log(environment.NX_SUPERSET_DOMAIN);
  // console.log(environment.NX_API_USER_ACCESS_URL);
    this.embedWithIframe();
  }

  // private embed() {
  //   console.log(this.quotedPriceId)
  //   this.error = false;
  //   embedDashboard({
  //     id: this._dashboardId, // given by the Superset embedding UI
  //     supersetDomain: process.env["NX_SUPERSET_DOMAIN"] as string,
  //     mountPoint: document.getElementById("superset-container") as HTMLElement, // any html element that can contain an iframe
  //     fetchGuestToken: async () => {
  //       const data: any = (await this.fetchGuestToken(
  //         this._dashboardId as string
  //       )) as Promise<string>;
  //       return data.token;
  //     },
  //     dashboardUiConfig: {
  //       //dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
  //       hideTitle: true,
  //       hideTab: true,
  //       filters: {
  //         expanded: false,
  //         visible: false,
  //       },
  //       urlParams: this.quotedPriceId ? this.quotedPriceId : {},
  //     },
  //   })
  //     .catch((error) => {
  //       debugger;
  //       (
  //         document.getElementById("superset-container") as HTMLElement
  //       ).style.display = "none";
  //       this.error = true;
  //     })
  //     .finally(() => {
  //       this.setIframeSize();
  //     });
  // }



  private async embedWithIframe() {
    console.log('Dashboard ID:', this._dashboardId);
    console.log('Quoted Price ID:', this.quotedPriceId);
    embedDashboard({
          id: environment.ID, // given by the Superset embedding UI
          // supersetDomain: process.env["https://reports.omnidb.dev.simadvisory.com"] as string
          // supersetDomain: "https://reports.omnidb.dev.simadvisory.com",
          supersetDomain: environment.NX_SUPERSET_DOMAIN,
          mountPoint: document.getElementById("superset-container") as HTMLElement, // any html element that can contain an iframe
          fetchGuestToken: async () => {
            const data: any = (await this.fetchGuestToken(
              this._dashboardId as string
            )) as Promise<string>;
            return data.token;
          },

    dashboardUiConfig: {
            //dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
            hideTitle: true,
            hideTab: true,
            filters: {
              expanded: false,
              visible: false,
            },
            urlParams: this.quotedPriceId ? this.quotedPriceId : {},
          },
        }).catch((error) => {
          console.error('Error embedding dashboard:', error);
          (document.getElementById("superset-container") as HTMLElement).style.display = "none";
          this.error = true;
        }).finally(() => {
          this.setIframeSize();
        });

  // const container = document.getElementById("superset-container");
  // if (container) {
  //   const observer = new MutationObserver(() => {
  //     const iframe = container.querySelector('iframe');
  //     if (iframe) {
  //       iframe.style.width = "1200px";
  //       iframe.style.height = "600px";
  //       iframe.style.minWidth = "100%";
  //       iframe.style.minHeight = "600px";
  //       observer.disconnect(); // Stop observing once iframe is found
  //     }
  //   });
  //   observer.observe(container, { childList: true, subtree: true });
  // }
    
    try {
      // Fetch the guest token first
      const tokenResponse: any = await this.fetchGuestToken(this._dashboardId);
      console.log('Token received:', tokenResponse);
      
      // Wait a bit for iframe to load, then send the token
      setTimeout(() => {
        this.sendTokenToIframe(tokenResponse.token);
      }, 1000);
      
    } catch (error) {
      console.error('Error fetching guest token:', error);
      this.error = true;
    }
  }

  private fetchGuestToken(dashboardId: string) {
    // console.log(dashboardId);
    console.log("inside fetchGuestToken");
    return lastValueFrom(
      this.httpClient.post(
        environment.NX_API_USER_ACCESS_URL,
        { dashboardIds: [environment.ID] }
      )
    );
  }

  private sendTokenToIframe(token: string) {
    const iframe = document.getElementById("superset-embed") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      console.log('Sending token to iframe:', token);
      
      // Send the guest token to the iframe
      iframe.contentWindow.postMessage(
        {
          key: "guest_token",
          value: token
        },
        "*" // In production, replace with your superset domain
      );
      
      // Also send URL parameters if needed
      if (this.quotedPriceId) {
        iframe.contentWindow.postMessage(
          {
            key: "url_params",
            value: this.quotedPriceId
          },
          "*"
        );
      }
    } else {
      console.error('Iframe not found or not ready');
    }
  }




  private setIframeSize() {
    const iframe = (
      document.getElementById("superset-container") as HTMLElement
    ).getElementsByTagName("iframe");
    if (iframe && iframe.length) {
      iframe[0].style.minWidth = "100%";
      iframe[0].style.minHeight = "100%";
    }
  }

  // private setIframeSize() {
  //   const iframe = document.getElementById("superset-container") as HTMLIFrameElement;

  //   if (iframe) {
  //     iframe.style.minWidth = "100%";
  //     iframe.style.minHeight = "600px";
  //     iframe.style.width = "1200px";    // Add this
  //     iframe.style.height = "600px";
  //   }
  
  // }



  // {"dashboardIds":["83bf3c43-0252-49ba-8b0d-1be67e59cdad"]}
  

}

// import { Component, Input, OnInit, ViewChild, ElementRef } from "@angular/core";
// import { embedDashboard } from "@superset-ui/embedded-sdk";
// import { lastValueFrom } from "rxjs";
// import { HttpClient } from "@angular/common/http";

// @Component({
//   selector: 'app-omni',
//   templateUrl: './omni.component.html',
//   styleUrls: ['./omni.component.scss']
// })
// export class OmniComponent implements OnInit {
//   @Input() quotedPriceId?: string|null;
//   @Input() set dashboardId(value: string) {
//     this._dashboardId = value;
//   }

//   @ViewChild('supersetContainer', { static: true }) supersetContainer!: ElementRef;

//   private _dashboardId: string = '';
//   error = false;

//   constructor(private httpClient: HttpClient) {}

//   ngOnInit(): void {
//     // if (!this._dashboardId) {
//     //   console.error('No dashboardId provided');
//     //   return;
//     // }
//     this.embed();
//   }

//   private async embed() {
//     console.log(this._dashboardId);
//     console.log(this.quotedPriceId);
//     console.log("inside embed");
//     this.error = false;
//     try {
//       const tokenResponse: any = await this.fetchGuestToken(this._dashboardId);
//       await embedDashboard({
//         id: this._dashboardId,
//         supersetDomain: process.env["NX_SUPERSET_DOMAIN"]!,
//         mountPoint: this.supersetContainer.nativeElement,
//         fetchGuestToken: () => Promise.resolve(tokenResponse.token),
//         dashboardUiConfig: {
//           hideTitle: true,
//           hideTab: true,
//           filters: { expanded: false, visible: false },
//           urlParams: this.quotedPriceId ? { quotedPriceId: this.quotedPriceId } : {}
//         },
        
//       });
//       this.setIframeSize();
//     } catch (error) {
//       console.error('Error embedding Superset dashboard', error);
//       this.supersetContainer.nativeElement.style.display = 'none';
//       this.error = true;
//     }
//   }

//   private fetchGuestToken(dashboardId: string) {
//     return lastValueFrom(
//       this.httpClient.post(`${process.env["NX_API_USER_ACCESS_URL"]}/reports/token`, {
//         dashboardIds: [dashboardId]
//       })
//     );
//   }

//   private setIframeSize() {
//     const iframe = this.supersetContainer.nativeElement.getElementsByTagName('iframe');
//     if (iframe && iframe.length) {
//       iframe[0].style.minWidth = '100%';
//       iframe[0].style.minHeight = '100%';
//     }
//   }
// }
